/* eslint-disable camelcase */
import breakpoints from '@constants/breakpoints';
import useWindowSize from '@hooks/useWindowSize/useWindowSize';
import analyticsTrack from '@lib/analytics/analyticsTrack';
import { IPrismicImage } from '@lib/prismic/types';
import React, { useEffect, useState } from 'react';
import { useTheme } from '@components/theme';
import classNames from 'classnames';
import ProductCard from '@components/shared/ProductCardV2/ProductCard';
import { v4 as uuidv4 } from 'uuid';
import { ICollectionWithProductCards } from '../../model/collectionWithProductCards';
import styles from './CollectionWithProductCards.module.scss';

const CollectionWithProductCards = ({
  vendorVariants,
  ctaLabel,
  ctaUrl,
  image,
  imageTitle
}: ICollectionWithProductCards) => {
  const theme = useTheme();
  const { width: windowWidth } = useWindowSize();
  const [isMobile, setIsMobile] = useState(false);
  const mobileBreakpoint = breakpoints['medium-tablet'];

  const analyticsLocation = `Shop Landing Page | Collection with Products | ${imageTitle}`;
  const analytics = {
    listId: uuidv4(),
    location: analyticsLocation,
  };

  useEffect(() => {
    const mobile = windowWidth && windowWidth < mobileBreakpoint;
    setIsMobile(!!mobile);
  }, [windowWidth]);

  const getImageUrl = ({ url, mobile_view }: IPrismicImage) => {
    if (windowWidth && windowWidth < mobileBreakpoint && mobile_view) {
      return mobile_view.url;
    }

    return url;
  };

  return (
    <section className={styles.ProductCards}>
      <div className={styles.Hero}>
        <div
          style={{ backgroundImage: `url(${getImageUrl(image)})` }}
          className={styles.MerchGroupImageWrapper}
        >
          <div className={styles.HeroBackdrop} />
        </div>
        <div className={styles.Content}>
          <h2 className={classNames(
            theme.styles.Header,
            { [theme.styles.Core2]: !isMobile },
            { [theme.styles.Core1]: isMobile },
          )}
          >
            {imageTitle}
          </h2>
          <a
            role="button"
            className={classNames(
              theme.styles.Button, {
                [theme.styles.Conflicting]: !isMobile,
                [theme.styles.Primary]: isMobile
              }
            )}
            href={ctaUrl}
            onClick={() => {
              analyticsTrack(`cta_clicked`, {
                title: `Shop Landing Page | Collection with Products | ${imageTitle}`,
                ctaLabel
              });
            }}
          >
            {ctaLabel}
          </a>
        </div>
      </div>

      <div className={styles.ProductsWrapper}>
        {vendorVariants.map(({ vendorVariant, imageIndex }) => (
          <ProductCard
            key={vendorVariant.id}
            product={vendorVariant}
            imageIndex={imageIndex}
            analytics={analytics}
            listPosition={
              vendorVariants.findIndex((vv) => vv.vendorVariant.id === vendorVariant.id)
            }
            isShopProductCard
            showSaleBanner
            showMaxDiscountText
          />
        ))}
      </div>
    </section>
  );
};

export default CollectionWithProductCards;
